import z from 'zod';

const AutomationStatusShape = z.object({
    id: z.string(),
    name: z.string(),
    status: z.string(),
    dayOfMonth: z.number().nullable().optional(),
});

const AutomationShape = z.object({
    id: z.string(),
    name: z.string(),
    status: z.string(),
});

export const shapes = {
    ReadAutomationStatusResponse: z.object({
        year: z.number(),
        month: z.number(),
        automations: z.array(AutomationStatusShape),
    }),
    ReadAutomationsResponse: z.array(AutomationShape),
};

export type ReadAutomationStatusResponse = z.infer<
    typeof shapes.ReadAutomationStatusResponse
>;

export type ReadAutomationsResponse = z.infer<
    typeof shapes.ReadAutomationsResponse
>;
